// MUSKOKATECH - save KEY as Cookie if passed in as Parameter 

function setFingerprintKey(obj){
   var orderKeyObj = document.getElementById("order-key");
   fingerprint_key = orderKeyObj.value;
   mtechSetCookie("_fingerprintKey", fingerprint_key);
}

function mtechFingerprintValidate(obj, reloadPage){
  var isValidKey = false;
  var pricesHidden = mtechPricesAreHidden;
   if (fingerprint_key.length >= 3){
     var msg = mtechIsOrderKeyValid(fingerprint_key, mtechIsFuneralHome);
      if (msg.length == 0){  
        mtechShowHidePricing();
        isValidKey = true;
      }
   }else if (fingerprint_key.length == 0){
        mtechShowHidePricing();
        isValidKey = false;
   }
    if (reloadPage && pricesHidden != mtechPricesAreHidden && !mtechPricesAreHidden){
        location.reload();
    }
    return isValidKey;
  }

  function initFingerprintForm(customerID){
   var fpOrderKeyObj = document.getElementById("order-key");
  if ((typeof fpOrderKeyObj !== 'undefined' && fpOrderKeyObj !== null) && fpOrderKeyObj.value == ""){
      fpOrderKeyObj.value = fingerprint_key;
   }
  }

function mtechGetCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for(var i=0; i<ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0)==' ') c = c.substring(1);
          if (c.indexOf(name) == 0) return c.substring(name.length,c.length);
      }
      return "";
  }       
function mtechSetCookie(name, value){
    var now = new Date();
    var time = now.getTime();
    var expireTime = time + 1000*36000;
    now.setTime(expireTime);
    var expires = "expires="+now.toUTCString();
    document.cookie = name+"="+value+";"+expires+";SameSite=none;Secure=true;path=/";
}

var fingerprint_key = "";
function deleteFingerprintKey()
{
  document.cookie = '_fingerprintKey' +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  fingerprint_key = "";
}


function initFingerprintData(){
  var mturl = new URL(location.href);
  var mtparams = new URLSearchParams(mturl.search);
  fingerprint_key = mtparams.get('fpkey');
  if ( fingerprint_key != null ) {
    mtechSetCookie("_fingerprintKey", fingerprint_key);
      //console.log("Set KEY by Param : "+fingerprint_key);
  }else{
      fingerprint_key = mtechGetCookie("_fingerprintKey");
      //console.log("Get KEY by Cookie: "+fingerprint_key);
  }
}

function mtechValidateOrderKey(key, isFuneralHome){
  var ret = true;
  var msg = mtechIsOrderKeyValid(key, isFuneralHome);
  if (msg.length > 0){
    ret = false;
  }
  var keyResult = document.getElementById("keyResult");
  keyResult.innerHTML = msg;
  return ret;
}

function mtechIsOrderKeyValid(key, isFuneralHome)
{
  var msg = "";
  if (key.length <= 0){
    if (isFuneralHome){
      return ""; // empty key is valid
    }else{
        msg= "Please enter the Order KEY supplied by your Funeral Home";
    }
  }else{
    var numPattern = /^[0-9\-]+$/;
    var keyArray = key.split("-");
    if (!numPattern.test(key)){
        msg= "Invalid: Key must contain only numbers and must be in the format: ###-#####";
    }else if (keyArray.length == 2){
      var coID = parseInt(keyArray[0]);
      if ( coID < 100 || coID > 99999){
          msg = "Invalid: The first part of the key must be the Funeral Home ID";
      }else if (parseInt(keyArray[1]) < 10000){
          msg = "Invalid: The second part of the key must be the Fingerprint/Decedent ID";
      }
    }else if (parseInt(key) < 100 || parseInt(key) > 99999){
        msg = "Invalid: The first part of the key must be the Funeral Home ID";
    }
  }
  return msg;
}
  
initFingerprintData();

// END MUSKOKATECH
